import Svgs from '@/components/ele/Svgs.vue'
import SearchCity from '@/components/ele/SearchCity/SearchCity.vue'
import Tag from '@/components/ele/Tag.vue'
import TimePicker from '@/components/ele/TimePicker.vue'
import MInput from '@/components/ele/MInput.vue'
import Header from '@/components/ele/Header.vue'
import NoData from "@/components/ele/NoData.vue";

const components = [
    Svgs,
    SearchCity,
    Tag,
    TimePicker,
    MInput,
    Header,
    NoData
]

const install = function(Vue) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default { components, install }